export default {
    title_list: 'Разрешения тарифных планов',
    title_page: 'Разрешение тарифного плана',
    title_create_page: 'Создать разрешение тарифного плана',
    title_edit_page: 'Изменить разрешение тарифного плана',

    filter: {
        labels: {
            title: 'Описание',
            active: 'Активна',
        }
    },

    table: {
        labels: {
            id: 'ID',
            title: 'Описание',
            position: 'Порядок',
            active: 'Активна',
        }
    },

    buttons: {

    },

    form: {
        slug: 'Ключ',
        title: 'Описание',
        note: 'Заметка',
        type: 'Тип',
        position: 'Порядок',
        active: 'Активна',
    },
}
